import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  ArrowRight, Film, Layers, Users, MapPin, SlidersHorizontal, Sparkles, Play,
  Wand2, GitBranch, Gauge, ShieldCheck, Clapperboard, Music, Megaphone, Award,
} from "lucide-react";
import Seo from "../components/Seo";
import { useI18n } from "../lib/i18n";
import { money } from "../lib/money";
import api from "../lib/api";

const HERO = "https://images.unsplash.com/photo-1612544409025-e1f6a56c1152?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxmaWxtJTIwc2V0JTIwY2luZW1hJTIwbGlnaHRpbmclMjBjYW1lcmElMjBjcmV3fGVufDB8fHx8MTc4NzgxNDQ0N3ww&ixlib=rb-4.1.0&q=85";
const NEON = "https://images.unsplash.com/photo-1601042879364-f3947d3f9c16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxuZW9uJTIwbmlnaHQlMjBjaXR5JTIwY2luZW1hdGljfGVufDB8fHx8MTc4Nzc3NzA1OXww&ixlib=rb-4.1.0&q=85";
const SET = "https://images.unsplash.com/photo-1632187989763-c9c620420b4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxjaW5lbWF0aWMlMjBmaWxtJTIwcHJvZHVjdGlvbiUyMGRhcmt8ZW58MHx8fHwxNzg3Nzc3MDU5fDA&ixlib=rb-4.1.0&q=85";
const PORTRAIT = "https://images.unsplash.com/photo-1532170579297-281918c8ae72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxjaW5lbWF0aWMlMjBkYXJrJTIwbW9vZHklMjBsaWdodGluZyUyMHBvcnRyYWl0fGVufDB8fHx8MTc4Nzc3NjU1Mnww&ixlib=rb-4.1.0&q=85";
const BOARD = "https://images.unsplash.com/photo-1780516000985-08f96af45c9c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxzdG9yeWJvYXJkJTIwc2tldGNoZXMlMjBmaWxtJTIwc2NlbmV8ZW58MHx8fHwxNzg3Nzc2NTUyfDA&ixlib=rb-4.1.0&q=85";
const RAIN = "https://images.unsplash.com/photo-1580895456895-cfdf02e4c23f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxjaW5lbWF0aWMlMjBuZW9uJTIwbmlnaHQlMjBjaXR5JTIwcG9ydHJhaXR8ZW58MHx8fHwxNzg3ODE0NDQ3fDA&ixlib=rb-4.1.0&q=85";
const TOKYO = "https://images.unsplash.com/photo-1542902093-d55926049754?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxjaW5lbWF0aWMlMjBuZW9uJTIwbmlnaHQlMjBjaXR5JTIwcG9ydHJhaXR8ZW58MHx8fHwxNzg3ODE0NDQ3fDA&ixlib=rb-4.1.0&q=85";
const STAGE = "https://images.unsplash.com/photo-1577190651915-bf62d54d5b36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxmaWxtJTIwc2V0JTIwY2luZW1hJTIwbGlnaHRpbmclMjBjYW1lcmElMjBjcmV3fGVufDB8fHx8MTc4NzgxNDQ0N3ww&ixlib=rb-4.1.0&q=85";
const CREW = "https://images.unsplash.com/photo-1632187981988-40f3cbaeef5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxmaWxtJTIwc2V0JTIwY2luZW1hJTIwbGlnaHRpbmclMjBjYW1lcmElMjBjcmV3fGVufDB8fHx8MTc4NzgxNDQ0N3ww&ixlib=rb-4.1.0&q=85";
const GRADE = "https://images.unsplash.com/photo-1574717024239-25253f4ef40a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxmaWxtJTIwZWRpdGluZyUyMHN0dWRpbyUyMGNvbG9yJTIwZ3JhZGluZyUyMG1vbml0b3JzfGVufDB8fHx8MTc4NzgxNDQ0N3ww&ixlib=rb-4.1.0&q=85";
const SUITE = "https://images.unsplash.com/photo-1607112812619-182cb1c7bb61?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxmaWxtJTIwZWRpdGluZyUyMHN0dWRpbyUyMGNvbG9yJTIwZ3JhZGluZyUyMG1vbml0b3JzfGVufDB8fHx8MTc4NzgxNDQ0N3ww&ixlib=rb-4.1.0&q=85";

const MOSAIC = [
  [RAIN, "9:16", "Fashion · night"],
  [TOKYO, "16:9", "Cyberpunk · anamorphic"],
  [STAGE, "1:1", "Studio · high key"],
  [GRADE, "16:9", "Colour · teal & orange"],
  [CREW, "4:5", "Behind the scenes"],
  [SUITE, "21:9", "Edit suite"],
];

const ENGINES = {
  en: [
    ["Cinema 2.5", "Seedance 2.5", "Up to 30s in one shot · 1080p · synchronised native audio and lip-sync", "#ff4b2b"],
    ["Pro", "Seedance 1 Pro", "Fast, sharp motion for production shots · 1080p", "#ffc76b"],
    ["Motion", "Kling 2.5 Turbo Pro", "Strong physics and camera control", "#00d5ff"],
    ["Draft", "Seedance 1 Lite", "Cheap iteration while you find the shot", "#8b5cf6"],
    ["Sketch", "Hailuo 02", "Lowest cost per second for previews", "#00ff9d"],
    ["Engine V", "Veo 3 Fast", "Native audio alternative engine", "#7de8ff"],
  ],
  fr: [
    ["Cinema 2.5", "Seedance 2.5", "Jusqu'à 30 s en un plan · 1080p · audio natif synchronisé et lip-sync", "#ff4b2b"],
    ["Pro", "Seedance 1 Pro", "Mouvement rapide et net pour les plans de production · 1080p", "#ffc76b"],
    ["Motion", "Kling 2.5 Turbo Pro", "Physique et contrôle caméra solides", "#00d5ff"],
    ["Draft", "Seedance 1 Lite", "Itération économique le temps de trouver le plan", "#8b5cf6"],
    ["Sketch", "Hailuo 02", "Coût par seconde le plus bas pour les prévisualisations", "#00ff9d"],
    ["Engine V", "Veo 3 Fast", "Moteur alternatif avec audio natif", "#7de8ff"],
  ],
};

const STATS = {
  en: [["6", "motion engines"], ["150", "director templates"], ["30 min", "max film length"], ["70%", "target gross margin"]],
  fr: [["6", "moteurs vidéo"], ["150", "templates réalisateur"], ["30 min", "durée de film max"], ["70 %", "marge brute cible"]],
};


const FEATURES = {
  en: [
    [Wand2, "AI Director", "One sentence becomes a full production plan: logline, acts, sequences, shots, camera and lighting direction."],
    [Layers, "Shot-by-shot architecture", "A five-minute film is 50–100 controllable shots. Regenerate shot 37 without touching the film."],
    [Users, "Character Lock", "Reusable characters with reference sheets, wardrobe and expressions injected into every generation."],
    [MapPin, "Location Lock", "Persistent sets remember architecture, weather, time of day and light direction."],
    [Clapperboard, "Storyboard first", "Approve cheap image frames before spending video credits."],
    [SlidersHorizontal, "Professional timeline", "Video, b-roll, music, voice, SFX, subtitles, VFX and colour on separate tracks."],
    [GitBranch, "Versions everywhere", "Every shot keeps V1…Vn. Every project keeps V1, Final, Director's Cut."],
    [Gauge, "Movies Credits", "Cost shown before you generate. Failed jobs refund automatically."],
    [ShieldCheck, "Model router + fallback", "Seedance, Veo and more behind one router. A provider outage does not stop your film."],
  ],
  fr: [
    [Wand2, "AI Director", "Une phrase devient un plan de production complet : logline, actes, séquences, plans, caméra et lumière."],
    [Layers, "Architecture plan par plan", "Un film de 5 minutes, c'est 50 à 100 plans contrôlables. Régénérez le plan 37 sans toucher au film."],
    [Users, "Character Lock", "Personnages réutilisables : références, garde-robe et expressions injectées à chaque génération."],
    [MapPin, "Location Lock", "Des décors persistants qui mémorisent architecture, météo, heure et direction de lumière."],
    [Clapperboard, "Storyboard d'abord", "Validez des images peu coûteuses avant de dépenser des crédits vidéo."],
    [SlidersHorizontal, "Timeline professionnelle", "Vidéo, b-roll, musique, voix, SFX, sous-titres, VFX et étalonnage sur pistes séparées."],
    [GitBranch, "Versions partout", "Chaque plan garde V1…Vn. Chaque projet garde V1, Final, Director's Cut."],
    [Gauge, "Movies Credits", "Coût affiché avant génération. Échec = remboursement automatique."],
    [ShieldCheck, "Routeur de modèles + fallback", "Seedance, Veo et d'autres derrière un routeur. Une panne fournisseur n'arrête pas votre film."],
  ],
};

const STEPS = {
  en: [
    ["One image", "Upload a portrait, a product or a location photo.", PORTRAIT],
    ["Five shots", "The shot generator proposes establishing, medium, close-up, over-shoulder and hero.", BOARD],
    ["One sequence", "Shots inherit character, location, light and grade. Continuity is checked.", SET],
    ["One film", "Sequences assemble on the timeline with music, voice and subtitles.", NEON],
  ],
  fr: [
    ["Une image", "Importez un portrait, un produit ou une photo de décor.", PORTRAIT],
    ["Cinq plans", "Le générateur propose plan large, moyen, gros plan, épaule et plan héros.", BOARD],
    ["Une séquence", "Les plans héritent personnage, décor, lumière et étalonnage. La continuité est vérifiée.", SET],
    ["Un film", "Les séquences s'assemblent sur la timeline avec musique, voix et sous-titres.", NEON],
  ],
};

const FAQ = {
  en: [
    ["Is this just another AI video generator?", "No. Studio Movies IA is a production environment. A project contains acts, sequences, scenes and shots. Each shot is its own generation with its own versions, which is how films longer than a single model's limit become possible."],
    ["How long can a film be?", "From 5 seconds to 30 minutes. Long-form is assembled from dozens or hundreds of shots — never requested as one giant generation."],
    ["What does a generation cost?", "Everything is priced in Movies Credits and the exact cost is displayed before you press Generate. A 5-second standard shot is around 45 credits."],
    ["Do unused credits expire?", "Subscription credits renew each period. Purchased credit packs do not expire."],
    ["Which AI models do you use?", "A model router selects the best available engine — Seedance, Veo and others — with automatic fallback. Admins can change models and pricing without a code change."],
    ["Can I use the videos commercially?", "Yes from the Creator plan upwards. The Free plan is watermarked and capped at 480p."],
  ],
  fr: [
    ["Est-ce encore un générateur vidéo IA ?", "Non. Studio Movies IA est un environnement de production. Un projet contient actes, séquences, scènes et plans. Chaque plan est une génération avec ses versions : c'est ce qui rend possible des films plus longs que la limite d'un modèle."],
    ["Quelle durée pour un film ?", "De 5 secondes à 30 minutes. Le format long est assemblé à partir de dizaines ou centaines de plans, jamais demandé en une seule génération."],
    ["Combien coûte une génération ?", "Tout est facturé en Movies Credits et le coût exact est affiché avant de générer. Un plan de 5 s en standard coûte environ 45 crédits."],
    ["Les crédits expirent-ils ?", "Les crédits d'abonnement se renouvellent chaque période. Les packs achetés n'expirent pas."],
    ["Quels modèles IA utilisez-vous ?", "Un routeur choisit le meilleur moteur disponible — Seedance, Veo et d'autres — avec bascule automatique. L'administration peut changer modèles et tarifs sans toucher au code."],
    ["Usage commercial autorisé ?", "Oui à partir du plan Creator. Le plan Free est filigrané et limité à 480p."],
  ],
};

export default function Landing() {
  const { locale, t } = useI18n();
  const L = (p) => `/${locale}${p}`;
  const [tpl, setTpl] = useState([]);
  const [packs, setPacks] = useState([]);
  const [step, setStep] = useState(0);

  useEffect(() => {
    api.get("/templates?limit=12").then(({ data }) => setTpl(data.templates.slice(0, 12))).catch(() => {});
    api.get("/billing/catalog").then(({ data }) => setPacks(data.packs || [])).catch(() => {});
  }, []);
  useEffect(() => {
    const i = setInterval(() => setStep((s) => (s + 1) % 4), 3200);
    return () => clearInterval(i);
  }, []);

  const steps = STEPS[locale];

  return (
    <div data-testid="landing-page">
      <Seo
        title={locale === "fr"
          ? "Studio Movies IA — Créez votre film avec l'IA"
          : "Studio Movies IA — Create your movie with AI"}
        description={locale === "fr"
          ? "Studio de production IA : AI Director, storyboard, plans cohérents, timeline multipiste, personnages persistants et export cinéma. D'une image à un film entier."
          : "AI film production studio: AI Director, storyboard, consistent shots, multi-track timeline, persistent characters and cinema export. From one image to an entire film."}
        locale={locale}
        path={`/${locale}`}
        altPath={`/${locale === "en" ? "fr" : "en"}`}
        image={HERO}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: FAQ[locale].map(([q, a]) => ({
            "@type": "Question", name: q,
            acceptedAnswer: { "@type": "Answer", text: a },
          })),
        }}
      />

      {/* ANNOUNCEMENT BAND */}
      <div className="relative z-20 pt-16">
        <div
          data-testid="home-announcement"
          className="overflow-hidden border-y border-[#ff4b2b]/25 bg-gradient-to-r from-[#1a0a06] via-[#301006] to-[#1a0a06]"
        >
          <div className="mx-auto flex max-w-[1400px] items-center justify-center gap-2.5 px-6 py-2.5 lg:px-10">
            <Award className="h-3.5 w-3.5 shrink-0 text-[#ffc76b]" />
            <p className="mono text-center text-[10.5px] uppercase tracking-[0.18em] text-[#ffd79a] sm:text-[11px]">
              {locale === "fr"
                ? "Le meilleur studio IA de tous les temps"
                : "The greatest AI studio of all time"}
            </p>
            <span className="hidden h-1.5 w-1.5 shrink-0 rounded-full bg-[#00ff9d] pulse-dot sm:block" />
          </div>
        </div>
      </div>

      {/* HERO */}
      <section className="relative grain min-h-[88vh] overflow-hidden">
        <div className="absolute inset-0">
          <img src={HERO} alt="Cinematic film set" className="h-full w-full object-cover opacity-[0.32]" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/65 to-[#050508]" />
          <div className="aurora absolute inset-0 opacity-90" />
          <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#050508] to-transparent" />
        </div>

        <div className="relative mx-auto max-w-[1400px] px-6 pb-28 pt-24 lg:px-10 lg:pt-32">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="max-w-[900px]"
          >
            <span className="glass mono inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-[11px] uppercase tracking-[0.18em] text-[#d3d5df]">
              <span className="h-1.5 w-1.5 rounded-full bg-[#00ff9d] pulse-dot" />
              {t("hero.badge")}
            </span>

            <h1 className="mt-8 font-display text-4xl font-semibold leading-[0.94] sm:text-5xl lg:text-[86px]">
              {t("hero.title1")}
              <br />
              <span className="sheen">{t("hero.title2")}</span>
            </h1>

            <p className="mt-8 max-w-[620px] text-base leading-relaxed text-[#c0c3d0] sm:text-lg">
              {t("hero.sub")}
            </p>

            <div className="mt-11 flex flex-wrap items-center gap-4">
              <Link
                to={L("/register")}
                data-testid="hero-cta-primary"
                className="btn-amber inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold"
              >
                {t("hero.cta1")} <ArrowRight className="h-4 w-4" />
              </Link>
              <Link
                to={L("/features")}
                data-testid="hero-cta-secondary"
                className="btn-ghost inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold"
              >
                <Play className="h-4 w-4" /> {t("hero.cta2")}
              </Link>
            </div>

            <div className="mt-16 grid max-w-[760px] grid-cols-2 gap-x-8 gap-y-6 sm:grid-cols-4">
              {STATS[locale].map(([n, l], i) => (
                <motion.div
                  key={l}
                  data-testid={`hero-stat-${i}`}
                  initial={{ opacity: 0, y: 14 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.7, delay: 0.35 + i * 0.09 }}
                >
                  <p className="font-display text-2xl font-semibold text-magma sm:text-3xl">{n}</p>
                  <p className="mono mt-1 text-[10px] uppercase tracking-[0.18em] text-[#8288a0]">{l}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>

        {/* film-strip mosaic */}
        <div className="relative overflow-hidden border-y border-white/[0.07] bg-black/50 py-4">
          <div className="film-holes absolute inset-x-0 top-0 h-1.5 opacity-40" />
          <div className="film-holes absolute inset-x-0 bottom-0 h-1.5 opacity-40" />
          <div className="marquee-track flex w-max gap-3" data-testid="film-strip-marquee">
            {[...MOSAIC, ...MOSAIC, ...MOSAIC].map(([src, ratio, label], i) => (
              <div key={`${src}-${i}`} className="relative h-[120px] w-[210px] shrink-0 overflow-hidden rounded-md border border-white/10">
                <img src={src} alt={label} loading="lazy" className="h-full w-full object-cover" />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 to-transparent px-2.5 py-1.5">
                  <p className="mono truncate text-[8.5px] uppercase tracking-[0.14em] text-[#c0c3d0]">{ratio} · {label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* MOTION ENGINES */}
      <section className="lit px-6 py-24 lg:px-10 lg:py-32">
        <div className="mx-auto max-w-[1400px]">
          <p className="overline">{locale === "fr" ? "Moteurs de rendu" : "Motion engines"}</p>
          <h2 className="mt-4 max-w-[820px] font-display text-3xl font-semibold sm:text-4xl lg:text-5xl">
            {locale === "fr"
              ? "Six moteurs vidéo réels derrière un seul routeur"
              : "Six real motion engines behind one router"}
          </h2>
          <p className="mt-5 max-w-[640px] text-base text-[#9194a6] md:text-lg">
            {locale === "fr"
              ? "Choisissez Preview, Production ou Cinema — le routeur sélectionne le moteur, bascule automatiquement en cas de panne et vous ne voyez jamais un nom de fournisseur."
              : "Pick Preview, Production or Cinema — the router selects the engine, fails over automatically, and you never see a provider name."}
          </p>

          <div className="mt-16 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {ENGINES[locale].map(([tier, model, desc, color], i) => (
              <motion.div
                key={tier}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.06 }}
                className="hot-border lift relative overflow-hidden rounded-2xl border border-[#212230] bg-[#0b0b11] p-6"
                data-testid={`engine-card-${i}`}
              >
                <span
                  className="absolute -right-16 -top-16 h-40 w-40 rounded-full opacity-[0.16] blur-2xl"
                  style={{ background: color }}
                />
                <div className="relative">
                  <span className="mono text-[10px] uppercase tracking-[0.2em]" style={{ color }}>
                    {tier}
                  </span>
                  <h3 className="mt-3 font-display text-lg font-medium">{model}</h3>
                  <p className="mt-3 text-[13px] leading-relaxed text-[#9194a6]">{desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* INTERACTIVE DEMO */}
      <section className="border-y border-white/[0.06] bg-[#08080d] px-6 py-24 lg:px-10 lg:py-32">
        <div className="mx-auto max-w-[1400px]">
          <p className="overline">{locale === "fr" ? "Démonstration" : "Live demonstration"}</p>
          <h2 className="mt-4 max-w-[720px] font-display text-3xl font-semibold sm:text-4xl lg:text-5xl">
            {t("demo.title")}
          </h2>
          <p className="mt-5 max-w-[560px] text-base text-[#9194a6] md:text-lg">{t("demo.sub")}</p>

          <div className="mt-16 grid gap-10 lg:grid-cols-[380px_1fr]">
            <div className="space-y-3">
              {steps.map(([label, desc], i) => (
                <button
                  key={label}
                  onClick={() => setStep(i)}
                  data-testid={`demo-step-${i}`}
                  className={`hot-border block w-full rounded-xl border p-5 text-left transition-colors duration-300 ${
                    step === i
                      ? "border-[#ff4b2b]/50 bg-[#ff4b2b]/[0.07]"
                      : "border-[#212230] bg-[#0e0e15] hover:border-[#383b4d]"
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <span className="mono text-[11px] text-[#ff4b2b]">0{i + 1}</span>
                    <span className="font-display text-base font-medium">{label}</span>
                  </div>
                  <p className="mt-2 text-[13px] leading-relaxed text-[#9194a6]">{desc}</p>
                </button>
              ))}
            </div>

            <div className="relative overflow-hidden rounded-2xl border border-[#212230] bg-[#0e0e15]">
              <motion.img
                key={step}
                src={steps[step][2]}
                alt={steps[step][0]}
                initial={{ opacity: 0, scale: 1.04 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                className="h-[300px] w-full object-cover sm:h-[440px] lg:h-[520px]"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black via-black/70 to-transparent p-6">
                <div className="mono flex flex-wrap items-center gap-4 text-[11px] uppercase tracking-[0.18em] text-[#9194a6]">
                  <span className="text-[#00d5ff]">● {steps[step][0]}</span>
                  <span>SHOT {String(step + 1).padStart(2, "0")}/04</span>
                  <span>00:0{step * 5} — 00:{(step + 1) * 5}</span>
                  <span>35MM ANAMORPHIC</span>
                </div>
              </div>
              <div className="absolute right-5 top-5 flex gap-1.5">
                {steps.map((_, i) => (
                  <span
                    key={i}
                    className={`h-1 rounded-full transition-all duration-500 ${
                      i === step ? "w-8 bg-[#ff4b2b]" : "w-3 bg-white/25"
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="px-6 py-24 lg:px-10 lg:py-32">
        <div className="mx-auto max-w-[1400px]">
          <p className="overline">{locale === "fr" ? "Le studio" : "The studio"}</p>
          <h2 className="mt-4 max-w-[760px] font-display text-3xl font-semibold sm:text-4xl lg:text-5xl">
            {t("feat.title")}
          </h2>

          <div className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-[#1a1b26] bg-[#1a1b26] sm:grid-cols-2 lg:grid-cols-3">
            {FEATURES[locale].map(([Icon, title, desc]) => (
              <div
                key={title}
                className="group relative bg-[#0b0b11] p-8 transition-colors duration-300 hover:bg-[#101118]"
              >
                <Icon className="h-5 w-5 text-[#ff4b2b] transition-transform duration-300 group-hover:scale-110" />
                <h3 className="mt-6 font-display text-lg font-medium">{title}</h3>
                <p className="mt-3 text-[13.5px] leading-relaxed text-[#9194a6]">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TEMPLATES */}
      <section className="overflow-hidden border-y border-white/[0.06] bg-[#08080d] py-24 lg:py-32">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
          <div className="flex flex-wrap items-end justify-between gap-6">
            <div>
              <p className="overline">Templates</p>
              <h2 className="mt-4 font-display text-3xl font-semibold sm:text-4xl lg:text-5xl">
                {t("tpl.title")}
              </h2>
              <p className="mt-5 max-w-[540px] text-base text-[#9194a6] md:text-lg">{t("tpl.sub")}</p>
            </div>
            <Link
              to={L("/templates")}
              data-testid="landing-templates-link"
              className="btn-ghost inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold"
            >
              {locale === "fr" ? "Voir tous les templates" : "Browse all templates"}
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        <div className="mt-14 flex w-max gap-5 pl-6 marquee-track lg:pl-10">
          {[...tpl, ...tpl].map((x, i) => (
            <div
              key={`${x.id}-${i}`}
              className="w-[260px] shrink-0 overflow-hidden rounded-xl border border-[#212230] bg-[#0e0e15]"
            >
              <img src={x.thumbnail} alt={x.title} className="h-[150px] w-full object-cover" loading="lazy" />
              <div className="p-4">
                <p className="mono text-[10px] uppercase tracking-[0.16em] text-[#ff4b2b]">{x.category}</p>
                <p className="mt-2 font-display text-sm font-medium">{x.title}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* WORKFLOW STRIP */}
      <section className="px-6 py-24 lg:px-10 lg:py-32">
        <div className="mx-auto max-w-[1400px]">
          <div className="grid gap-14 lg:grid-cols-2 lg:gap-24">
            <div>
              <p className="overline">{locale === "fr" ? "Pipeline" : "Pipeline"}</p>
              <h2 className="mt-4 font-display text-3xl font-semibold sm:text-4xl lg:text-[44px]">
                {locale === "fr"
                  ? "Idée → scénario → storyboard → plans → montage → film"
                  : "Idea → script → storyboard → shots → edit → film"}
              </h2>
              <p className="mt-6 text-base leading-relaxed text-[#9194a6] md:text-lg">
                {locale === "fr"
                  ? "Chaque étape est un objet réel en base : projet, acte, séquence, scène, plan, génération, version. C'est cette hiérarchie qui rend la production longue possible — et récupérable quand un plan échoue."
                  : "Every step is a real object in the database: project, act, sequence, scene, shot, generation, version. That hierarchy is what makes long-form production possible — and recoverable when one shot fails."}
              </p>
              <div className="mt-10 space-y-4">
                {[
                  [Film, locale === "fr" ? "Mode économique" : "Cost-control tiers", "Preview → Standard → Production → Cinema"],
                  [Sparkles, locale === "fr" ? "Continuity Engine" : "Continuity Engine", locale === "fr" ? "Alertes vêtements, lumière, décor, axe caméra" : "Wardrobe, light, set and camera-axis warnings"],
                  [Music, locale === "fr" ? "Audio complet" : "Full audio bed", locale === "fr" ? "Musique, voix, SFX, ambiance, sous-titres" : "Music, voice, SFX, ambience, subtitles"],
                ].map(([Icon, title, desc]) => (
                  <div key={title} className="flex gap-4 rounded-xl border border-[#1a1b26] bg-[#0b0b11] p-5">
                    <Icon className="mt-0.5 h-4 w-4 shrink-0 text-[#00d5ff]" />
                    <div>
                      <p className="font-display text-sm font-medium">{title}</p>
                      <p className="mono mt-1 text-[11px] text-[#9194a6]">{desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative overflow-hidden rounded-2xl border border-[#212230]">
              <img src={SET} alt="Production set" className="h-full min-h-[420px] w-full object-cover" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-7">
                <div className="track-row rounded-lg border border-white/10 bg-black/60 p-4 backdrop-blur-md">
                  {["VIDEO", "MUSIC", "VOICE", "SFX"].map((k, i) => (
                    <div key={k} className="flex items-center gap-3 py-1.5">
                      <span className="mono w-14 text-[9px] text-[#9194a6]">{k}</span>
                      <div className="relative h-3 flex-1 rounded bg-white/[0.04]">
                        <div
                          className="absolute h-3 rounded"
                          style={{
                            left: `${i * 9}%`,
                            width: `${58 - i * 8}%`,
                            background: i === 0 ? "#ff4b2b" : i === 1 ? "#00d5ff44" : "#ffffff20",
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* GALLERY MOSAIC */}
      <section className="lit border-t border-white/[0.06] px-6 py-24 lg:px-10 lg:py-32">
        <div className="mx-auto max-w-[1400px]">
          <div className="flex flex-wrap items-end justify-between gap-6">
            <div>
              <p className="overline">{locale === "fr" ? "Formats" : "Formats"}</p>
              <h2 className="mt-4 max-w-[720px] font-display text-3xl font-semibold sm:text-4xl lg:text-5xl">
                {locale === "fr"
                  ? "Un film, tous les formats"
                  : "One film, every format"}
              </h2>
              <p className="mt-5 max-w-[560px] text-base text-[#9194a6] md:text-lg">
                {locale === "fr"
                  ? "16:9, 9:16, 1:1, 4:5, 21:9 et 2.39:1 — exportés depuis le même projet, avec sous-titres incrustés et musique mixée côté serveur."
                  : "16:9, 9:16, 1:1, 4:5, 21:9 and 2.39:1 — exported from the same project, with burned-in subtitles and music muxed server-side."}
              </p>
            </div>
            <Link to={L("/pricing")} className="btn-ghost inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold">
              {locale === "fr" ? "Voir les offres" : "See the plans"} <ArrowRight className="h-4 w-4" />
            </Link>
          </div>

          <div className="mt-16 grid auto-rows-[170px] grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
            {[
              [TOKYO, "lg:col-span-2 lg:row-span-2", "16:9 · Cyberpunk"],
              [RAIN, "row-span-2", "9:16 · Fashion"],
              [STAGE, "", "1:1 · Studio"],
              [GRADE, "", "Colour grade"],
              [CREW, "", "Behind the scenes"],
              [SUITE, "lg:col-span-2", "21:9 · Edit suite"],
              [BOARD, "", "Storyboard"],
            ].map(([src, span, label], i) => (
              <motion.figure
                key={`${src}-${i}`}
                initial={{ opacity: 0, scale: 0.97 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.65, delay: i * 0.05 }}
                className={`lift group relative overflow-hidden rounded-xl border border-[#212230] ${span}`}
                data-testid={`gallery-tile-${i}`}
              >
                <img
                  src={src}
                  alt={label}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-1000 group-hover:scale-[1.06]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-transparent" />
                <figcaption className="mono absolute bottom-3 left-3 text-[9.5px] uppercase tracking-[0.16em] text-[#d3d5df]">
                  {label}
                </figcaption>
              </motion.figure>
            ))}
          </div>
        </div>
      </section>

      {/* Thematic packs — the no-studio-needed shortcut */}
      <section
        className="lit border-t border-white/[0.06] px-6 py-24 lg:px-10 lg:py-32"
        data-testid="thematic-packs-section"
      >
        <div className="mx-auto max-w-[1400px]">
          <div
            className="flex flex-col gap-5 rounded-2xl border border-[#ff4b2b]/35 bg-[#ff4b2b]/[0.06] p-7 sm:flex-row sm:items-center sm:justify-between"
            data-testid="quick-create-banner"
          >
            <div className="flex items-start gap-4">
              <Gauge className="mt-0.5 h-6 w-6 shrink-0 text-[#ff4b2b]" />
              <div>
                <p className="font-display text-base font-medium md:text-lg">
                  {locale === "fr"
                    ? "Pas besoin de maîtriser le studio complet pour créer vite"
                    : "You don't need the full studio to create fast"}
                </p>
                <p className="mt-2 max-w-[620px] text-[13.5px] leading-relaxed text-[#c0c3d0]">
                  {locale === "fr"
                    ? "Choisissez un pack thématique, écrivez une phrase, et la Création rapide écrit le découpage, choisit le moteur le moins cher et lance chaque plan. Le studio complet reste là quand vous voudrez tout contrôler."
                    : "Pick a thematic pack, write one sentence, and Quick Create writes the shot list, picks the cheapest engine and launches every shot. The full studio is there when you want total control."}
                </p>
              </div>
            </div>
            <Link
              to="/studio/quick"
              data-testid="quick-create-cta"
              className="btn-amber inline-flex shrink-0 items-center gap-2 rounded-full px-6 py-3 text-[13px] font-semibold"
            >
              {locale === "fr" ? "Créer en 3 clics" : "Create in 3 clicks"}
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>

          <p className="overline mt-16">{locale === "fr" ? "Packs thématiques" : "Thematic packs"}</p>
          <h2 className="mt-4 max-w-[760px] font-display text-3xl font-semibold sm:text-4xl lg:text-5xl">
            {locale === "fr" ? "Un pack par type de film, prêt à tourner"
                             : "One pack per kind of film, ready to shoot"}
          </h2>
          <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {[
              ["short_film", "short_film", Film, "Short Film Pack",
               locale === "fr" ? "Une histoire en 6 plans : situation, bascule, chute." : "A story in 6 shots: setup, turn, ending."],
              ["commercial", "commercial", Megaphone, "Commercial Pack",
               locale === "fr" ? "Accroche, plan héros, bénéfice, appel à l'action." : "Hook, hero shot, benefit, call to action."],
              ["cinematic", "cinematic", Clapperboard, "Cinematic Pack",
               locale === "fr" ? "L'énergie d'une bande-annonce, en 8 plans." : "Trailer energy, in 8 shots."],
              ["music_video", "music_video", Music, "Music Video Pack",
               locale === "fr" ? "Performance et ambiance, montés au rythme." : "Performance and mood, cut to the beat."],
              ["p1500", "social", Sparkles, locale === "fr" ? "Accroche réseaux" : "Social Hook",
               locale === "fr" ? "Vertical, accroche dès la première seconde." : "Vertical, hooked in the first second."],
              ["director_pack", null, Award, "Director Pack",
               locale === "fr" ? "Le volume de crédits pour produire en continu." : "The credit volume to produce continuously."],
            ].map(([code, theme, Icon, label, blurb], i) => {
              const pack = (packs || []).find((p) => p.code === code);
              return (
                <motion.div
                  key={code}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.45, delay: i * 0.07 }}
                  data-testid={`landing-pack-${code}`}
                  className="hot-border flex flex-col rounded-2xl border border-[#212230] bg-[#0b0b11] p-6 transition-colors duration-300 hover:bg-[#101118]"
                >
                  <Icon className="h-5 w-5 text-[#ff4b2b]" />
                  <p className="mt-5 font-display text-[15px] font-medium">{label}</p>
                  <p className="mt-2 flex-1 text-[12.5px] leading-relaxed text-[#9194a6]">{blurb}</p>
                  {pack && (
                    <p className="mono mt-5 text-[11px] text-[#00d5ff]">
                      {Number(pack.credits).toLocaleString()} cr · {money(pack.price, locale, 2)}
                    </p>
                  )}
                  <Link
                    to={theme ? `/studio/quick?theme=${theme}` : L("/pricing")}
                    className="btn-ghost mt-5 rounded-full py-2.5 text-center text-[12px] font-semibold"
                  >
                    {theme
                      ? (locale === "fr" ? "Créer maintenant" : "Create now")
                      : (locale === "fr" ? "Voir le pack" : "See the pack")}
                  </Link>
                </motion.div>
              );
            })}
          </div>
          <Link
            to={`/${locale}/pricing`}
            className="mono mt-10 inline-flex items-center gap-2 text-[12px] text-[#ffc76b]"
            data-testid="landing-packs-pricing-link"
          >
            {locale === "fr" ? "Voir tous les packs et tarifs" : "See every pack and price"}
            <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        </div>
      </section>

      {/* FAQ */}
      <section className="border-t border-white/[0.06] bg-[#08080d] px-6 py-24 lg:px-10 lg:py-32">
        <div className="mx-auto max-w-[1000px]">
          <h2 className="font-display text-3xl font-semibold sm:text-4xl lg:text-5xl">{t("faq.title")}</h2>
          <div className="mt-14 divide-y divide-white/[0.07]">
            {FAQ[locale].map(([q, a]) => (
              <details key={q} className="group py-6" data-testid="faq-item">
                <summary className="flex cursor-pointer list-none items-start justify-between gap-6">
                  <span className="font-display text-base font-medium md:text-lg">{q}</span>
                  <span className="mono mt-1 shrink-0 text-[#ff4b2b] transition-transform duration-300 group-open:rotate-45">
                    +
                  </span>
                </summary>
                <p className="mt-4 max-w-[760px] text-sm leading-relaxed text-[#9194a6]">{a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="relative grain overflow-hidden px-6 py-28 lg:px-10 lg:py-36">
        <img src={NEON} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050508] via-black/70 to-[#050508]" />
        <div className="relative mx-auto max-w-[900px] text-center">
          <h2 className="font-display text-3xl font-semibold leading-tight sm:text-5xl lg:text-[64px]">
            {t("cta.final")}
          </h2>
          <div className="mt-11 flex flex-wrap justify-center gap-4">
            <Link
              to={L("/register")}
              data-testid="final-cta"
              className="btn-amber inline-flex items-center gap-2 rounded-full px-8 py-4 text-sm font-semibold"
            >
              {t("hero.cta1")} <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to={L("/pricing")}
              className="btn-ghost rounded-full px-8 py-4 text-sm font-semibold"
            >
              {t("nav.pricing")}
            </Link>
          </div>
          <p className="mono mt-8 text-[11px] uppercase tracking-[0.2em] text-[#8288a0]">
            {locale === "fr" ? "50 crédits offerts · aucune carte requise" : "50 free credits · no card required"}
          </p>
        </div>
      </section>
    </div>
  );
}
